<nav class="nav bg-primary">
  <div class="d-flex ps-5 pt-3 pb-3 align-items-center">
    <a class="d-none d-md-block">
      <img src="./assets/images/LOGOS_PNG/co_footer.png" height="50" alt="" loading="lazy">
    </a>

    <div class="vr mx-3 border border-white"></div>

    <a class="d-none d-md-block">
      <img src="./assets/images/LOGOS_PNG/gov_footer.png" height="25" alt="" loading="lazy">
    </a>
  </div>
</nav>
